import { useEffect, useState, useCallback } from 'react';

// Full-screen viewer for any image marked data-zoomable, such as the dealer
// certificates. Mount once, next to CartDrawer. Tap or press Enter on the
// image to open; tap outside, the close button or Escape to close.

export default function ImageViewer() {
  const [img, setImg] = useState(null);
  const close = useCallback(() => setImg(null), []);

  useEffect(() => {
    const open = (el) => setImg({ src: el.currentSrc || el.src, alt: el.alt || '' });
    const onClick = (e) => {
      const el = e.target && e.target.closest ? e.target.closest('img[data-zoomable]') : null;
      if (el) { e.preventDefault(); open(el); }
    };
    const onKey = (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches && e.target.matches('img[data-zoomable]')) {
        e.preventDefault();
        open(e.target);
      }
    };
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, []);

  useEffect(() => {
    if (!img) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [img, close]);

  if (!img) return null;

  return (
    <div role="dialog" aria-modal="true" aria-label={img.alt || 'Image'} onClick={close}
      className="fixed inset-0 z-[70] flex flex-col bg-black/90">
      <div className="flex h-14 shrink-0 items-center justify-between gap-3 px-4 text-white">
        <p className="min-w-0 truncate text-sm font-semibold">{img.alt}</p>
        <button type="button" onClick={close} aria-label="Close"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg hover:bg-white/10">
          <svg viewBox="0 0 20 20" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <path d="M5 5l10 10M15 5L5 15" strokeLinecap="round" />
          </svg>
        </button>
      </div>
      <div className="flex min-h-0 flex-1 items-center justify-center p-3">
        <img src={img.src} alt={img.alt} onClick={(e) => e.stopPropagation()}
          className="max-h-full max-w-full rounded-md bg-white object-contain" />
      </div>
      <a href={img.src} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}
        className="mx-auto mb-5 mt-1 rounded-lg border border-white/30 px-4 py-2 text-sm font-semibold text-white hover:bg-white/10">
        Open full size
      </a>
    </div>
  );
}
